/* eslint-disable max-len */
import React, { memo } from 'react';

import { COLOR, ENTITY_COLOR } from '@/theme/colors';

import { Props } from './types';

const PremiumStarIcon = ({
    width,
    height,
    color = COLOR.white,
    secondaryColor = ENTITY_COLOR.dashboard,
}: Props) => {
    return (
        <svg
            id="Layer_2"
            width={width}
            height={height}
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
        >
            <g id="Layer_1" data-name="Layer 1">
                <g>
                    <path
                        fill={color}
                        d="M48,24C48,10.75,37.25,0,24,0S0,10.75,0,24s10.75,24,24,24,24-10.75,24-24"
                    />
                    <path
                        fill={secondaryColor}
                        d="M15.35,34.4c-3.41,1.17-5.29.28-5.29.28l-4.06-8.05s2.21.58,5.24-1.89c3.04-2.48,6.73-13.87,6.73-13.87l6.03,11.95s-4.89,10.28-8.65,11.59"
                    />
                    <path
                        fill={secondaryColor}
                        d="M32.65,34.4c3.41,1.17,5.3.28,5.3.28l4.05-8.05s-2.21.58-5.24-1.89c-3.03-2.48-6.73-13.87-6.73-13.87l-6.03,11.95s4.9,10.28,8.65,11.59"
                    />
                    <path
                        fill={color}
                        d="M24,46.9c-12.63,0-22.9-10.27-22.9-22.9S11.37,1.1,24,1.1s22.9,10.27,22.9,22.9-10.27,22.9-22.9,22.9M24,2.07C11.91,2.07,2.07,11.91,2.07,24s9.84,21.93,21.93,21.93,21.93-9.84,21.93-21.93S36.09,2.07,24,2.07"
                    />
                </g>
            </g>
        </svg>
    );
};

export default memo(PremiumStarIcon);
